/**
 * API клиент для профиля пользователя
 */

const API_BASE = '/api';

import { getAuthHeaders } from "./auth-headers";

export async function getProfile() {
  const res = await fetch(`${API_BASE}/user/profile`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch profile');
  return res.json();
}

export async function getCertificates() {
  const res = await fetch(`${API_BASE}/user/certificates`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch certificates');
  return res.json();
}

export async function getAchievements() {
  const res = await fetch(`${API_BASE}/user/achievements`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch achievements');
  return res.json();
}

export async function getAllAchievements() {
  const res = await fetch(`${API_BASE}/user/achievements/all`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch all achievements');
  return res.json();
}